import { useMemo, forwardRef } from 'react'
import { Fingerprint } from '@material-ui/icons'
import { useAuth } from '@praxis/component-auth'
import { StyledListItemText, UseStyles } from '../StyledList'
import { ListItem, ListItemIcon } from '@material-ui/core'
import { arrayOf, string, func } from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'

export const AuditLogButton = (props) => {
  const auth = useAuth()
  const { isAuthorized, isAuthenticated } = auth
  const classes = UseStyles()

  const { groups, text, to, onClose } = props
  const renderLink = useMemo(
    () =>
      forwardRef((itemProps, ref) => (
        <RouterLink
          underline="none"
          exact="true"
          to={to}
          ref={ref}
          {...itemProps}
        />
      )),
    [to],
  )

  if (isAuthenticated()) {
    if (isAuthorized(groups)) {
      return (
        <ListItem
          button
          onClick={onClose}
          component={renderLink}
          className={classes.nested}
        >
          <ListItemIcon>
            <Fingerprint />
          </ListItemIcon>
          <StyledListItemText primary={text} />
        </ListItem>
      )
    }
  }
  return null
}

AuditLogButton.propTypes = {
  groups: arrayOf(string).isRequired,
  to: string.isRequired,
  text: string.isRequired,
  onClose: func.isRequired,
}
